import { IListConfig } from "./ListConfig";

export const ListDefaults: IListConfig = {
    placeholders: {
        dataMissing: '[Missing]',
        dataTBC: '[To be completed]'
    },
    columnWidths: {
        editIcon: 30,
        rag: 130,
        date: 75,
        user: 150
    }
};
